// Match backend conversion_engine.money: Decimal, currency scale 2, HALF_UP.
// API/storage amounts remain ordinary JSON numbers; this only prevents preview
// arithmetic from introducing binary floating-point drift.
import Decimal from 'decimal.js';
const Money = Decimal.clone({precision:40,rounding:Decimal.ROUND_HALF_UP});
const number = value => new Money(Number(value || 0));
export const roundedMoney = value => number(value).toDecimalPlaces(2).toNumber();
export function billPreview(lines,discount,payments,advance=0) {
 const subtotal=lines.reduce((sum,row)=>sum.plus(number(row.unit_price).toDecimalPlaces(2).times(number(row.quantity)).toDecimalPlaces(2)),new Money(0));
 const total=subtotal.minus(number(discount).toDecimalPlaces(2));
 const paid=payments.reduce((sum,row)=>sum.plus(number(row.amount).toDecimalPlaces(2)),new Money(0));
 const advancePaid=number(advance).toDecimalPlaces(2),received=advancePaid.plus(paid);
 return {subtotal:subtotal.toNumber(),total:total.toNumber(),paid:paid.toNumber(),totalReceived:received.toNumber(),balance:total.minus(advancePaid).toNumber(),due:total.minus(received).toNumber()};
}
export function billingCashReconciliation(report) {
 const cash=value=>number(value).toDecimalPlaces(2);
 const expenses=(report.cash_expenses || []).reduce((sum,row)=>sum.plus(cash(row.amount)),new Money(0));
 const expected=cash(report.previous_cash_in_counter).plus(cash(report.cash_sales)).minus(expenses).minus(cash(report.cash_deposit));
 return {totalCashExpenses:expenses.toNumber(),expectedCash:expected.toNumber(),discrepancy:cash(report.actual_cash_in_counter).minus(expected).toNumber()};
}
